import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import ManagementEntrance from '../Shared/ManagementEntrance/ManagementEntrance';
import SongListPreview from '../Shared/SongListPreview/SongListPreview';
import {goToPage, setTitle, getCategory, getSubscribers, pageLoaded, initFundial, reportAnalytics} from '../fundialSlice';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {isMobile, isTablet} from 'react-device-detect';
import DownloadSongPopUp from '../Shared/DownloadSongPopUp/DownloadSongPopUp';

const LobbyPage = (props) => {
  const categoryId = 15624;

  async function getCatalog() {
    props.showAppLoader();
    await props.getCategory(categoryId);
    props.hideAppLoader();
    props.pageLoaded();
  }

  // async function getSubscribers() {
  //   props.showAppLoader();
  //   await Promise.all([getCatalog(true), props.getSubscribers()]);
  //   props.hideAppLoader();
  //   setFinishLoaded(true);
  //   props.pageLoaded();
  // }

  useExtendedEffect((runSideEffects) => {
    window.scrollTo(0, 0);
    props.setTitle({titleBold: 'המתנה נעימה', titleRegular: ''});

    if(!props.catagories[categoryId]){
      getCatalog();
    }

    if (runSideEffects()) {
      props.reportAnalytics({
        eventCategory: 'fundial',
        eventAction: 'HN_Lobby',
        eventLabel: '',
      });
    }
  }, []);

  // useExtendedEffect((runSideEffects) => {
  //   if (props.isAuthenticateFinish) {
  //     if(props.isAuthenticated){
  //       getSubscribers();
  //     } else {
  //       props.showAppLoader();
  //       props.initFundial();
  //       getCatalog(false);
  //     }
  //   }
  // }, [props.isAuthenticateFinish]);

  function handleOnClick_SongListPreview() {
    props.reportAnalytics({
      eventCategory: 'fundial',
      eventAction: 'HN_Lobby_MainCatButton',
      eventLabel: '',
    });
    props.goToPage({page: 'catalogPage'});
  }

  function view() {
    if (props.subscribers.length == 0) {
      return (
        <div>
          {props.catagories[categoryId] && (
            <SongListPreview
              items={props.catagories[categoryId].items}
              title='הורידו שיר'
              subTitle='חדש'
              buttonText='לכל השירים'
              onclick={handleOnClick_SongListPreview}
            />
          )}
          <div className='component-separator' style={{height: isMobile && !isTablet ? '35px' : '60px'}}></div>
          <ManagementEntrance />
          <DownloadSongPopUp />
        </div>
      );
    } else {
      return (
        <div>
          <ManagementEntrance />
          <div className='component-separator'></div>
          {props.catagories[categoryId] && (
            <SongListPreview
              items={props.catagories[categoryId].items}
              title='הורידו שיר'
              subTitle='חדש'
              buttonText='לכל השירים'
              onclick={handleOnClick_SongListPreview}
            />
          )}
          <DownloadSongPopUp />
        </div>
      );
    }
  }

  return <div className='lobby-page'>{view()}</div>;
};

const mapStateToProps = (state) => {

  const {
    isOtpAuthenticated,
    isFullAuthenticated,
    isOtpExtendedAuthenticated,
    isSilentOtpAuthenticated
  } = state.authentication.loginData;

  return {
    isAuthenticated: isOtpAuthenticated || isFullAuthenticated || isOtpExtendedAuthenticated || isSilentOtpAuthenticated,
    isAuthenticateFinish: state.authentication.isAuthenticateFinish,
    catagories: state.fundialPage.catagories,
    subscribers: state.fundialPage.subscribers,
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle,
  showAppLoader,
  hideAppLoader,
  getCategory,
  getSubscribers,
  pageLoaded,
  initFundial,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(LobbyPage);
